import { create } from "zustand";
import { axiosHelper, tokenHelper } from "./helpers";

export const usePeriodicReportStore = create((set) => ({
  isSending: false,
  error: null,

  sendPeriodicReport: async ({
    siteIds,
    startDate,
    endDate,
    toEmail,
    cc,
    bcc,
    timezone,
  }) => {
    set({ isSending: true, error: null });
    try {
      const accessToken = await tokenHelper.getToken();
      const response = await axiosHelper.post(
        "/periodic-report/send",
        {
          siteIds,
          startDate,
          endDate,
          toEmail,
          cc,
          bcc,
          timezone,
        },
        {
          headers: { Authorization: `Bearer ${accessToken}` },
        }
      );
      set({ isSending: false });
      return response;
    } catch (e) {
      console.error("Error sending periodic report:", e);
      set({
        isSending: false,
        error: e?.response?.data?.message || "Failed to send report",
      });
      throw e;
    }
  },
}));
